import React, { Component } from 'react';
import moment from 'moment';

import ellipsis from 'assets/images/ellipsis.gif';
import pc from 'assets/images/pc-icon.png';
import server from 'assets/images/server-icon.png';
import laptop from 'assets/images/laptop-icon.png';
import check from 'assets/images/check.png';

import './styles.scss';

class ConnectionStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

 
  getStatusFromAge(ageSec) {
    if (ageSec === null) return 'disconnected';
    if (ageSec < 5) return 'connected';
    if (ageSec < 20) return 'reconnecting';
    return 'disconnected';
  }

  renderLabel(status, hint) {
    if (status === 'connected') return 'connected ✅';
    if (status === 'reconnecting') return 'reconnecting… ⏳';

    return hint ? ('disconnected ❌ (reason: ' + hint + ')') : 'disconnected ❌';
  }

  render() {
    const props = this.props;

    var now = moment();
    var serverAge = null;
    var clientAge = null;

    if (props.lastServerPong) {
      serverAge = Math.abs(props.lastServerPong.diff(now, 'second'));
    }
    if (props.lastClientPong) {
      clientAge = Math.abs(props.lastClientPong.diff(now, 'second'));
    }

    var serverStatus = this.getStatusFromAge(serverAge);
    var clientStatus = this.getStatusFromAge(clientAge);

    var serverConnection = serverStatus === 'connected';
    var clientConnection = clientStatus === 'connected';

    var serverConnectionSrc = serverConnection ? check : ellipsis;
    var clientConnectionSrc = clientConnection ? check : ellipsis;

    var overallStatus = props.netStatus || (
      (serverStatus === 'connected' && clientStatus === 'connected')
        ? 'connected'
        : (serverStatus === 'reconnecting' || clientStatus === 'reconnecting')
          ? 'reconnecting'
          : 'disconnected'
    );

    var overallHint = props.netHint || (
      overallStatus === 'disconnected'
        ? (serverStatus !== 'connected'
            ? 'server unreachable'
            : 'client unreachable')
        : (overallStatus === 'reconnecting'
            ? 'trying to restore connection'
            : '')
    );

    return (
      <div className="connectionStatus">
        <img src={pc} alt="PC" className="connectionStatus__device" />
        <img src={serverConnectionSrc} alt="" className="connectionStatus__icon" />
        <img src={server} alt="SERVER" className="connectionStatus__device" />
        <img src={clientConnectionSrc} alt="" className="connectionStatus__icon" />
        <img src={laptop} alt="REMOTE" className="connectionStatus__device" />

        <div className="connectionStatus__labels" style={{ marginTop: 8 }}>
          <div style={{ fontSize: 12, color:'black' }}>
            server: {this.renderLabel(serverStatus, serverStatus === 'disconnected' ? 'no pong' : '')}
          </div>
          <div style={{ fontSize: 12, color:'black' }}>
            client: {this.renderLabel(clientStatus, clientStatus === 'disconnected' ? 'no pong' : '')}
          </div>
          <div style={{ fontSize: 12, fontWeight: 600, marginTop: 4, color:'black' }}>
            status: {this.renderLabel(overallStatus, overallHint)}
          </div>
        </div>
      </div>
    );
  }
}

export default ConnectionStatus;
